import React, { useEffect, useState, useContext } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link, useNavigate } from 'react-router-dom';
import { LanguageContext } from '../Context/LanguageContext';

function Navbar() {
    const [isScrolled, setIsScrolled] = useState(false);
    const { language, setLanguage } = useContext(LanguageContext);
    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({ duration: 800, once: true });

        const handleScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const routes = [
        { name: language === 'ar' ? 'الرئيسية' : 'Home', link: '/' },
        { name: language === 'ar' ? 'العلامات التجارية' : 'Brands', link: '#brands' },
        { name: language === 'ar' ? 'الخدمات' : 'Services', link: '#services' },
        { name: language === 'ar' ? 'من نحن' : 'About', link: '#about' },
        { name: language === 'ar' ? 'اتصل بنا' : 'Contact', link: '#contact' },
    ];

    const handleNavigation = (e, link) => {
        if (link.startsWith('#')) {
            e.preventDefault();
            const targetId = link.substring(1);
            const target = document.getElementById(targetId);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            navigate(link);
        }
    };

    return (
        <>
            <nav 
                className={`navbar navbar-expand-lg fixed-top px-4 py-2`}
                data-aos="fade-down"
                dir={language === 'ar' ? 'rtl' : 'ltr'}
            >
                <div className={`container ${isScrolled ? 'scrolled' : ''}`}>
                    <Link className="navbar-brand" to="/">
                        <img 
                            src="/assets/images/logo1.png" 
                            alt="logo" 
                            className="img-fluid"
                            style={{ width: '50px', height: 'auto' }} 
                        />
                    </Link>

                    <button 
                        className="navbar-toggler text-white" 
                        type="button" 
                        data-bs-toggle="collapse" 
                        data-bs-target="#navbarNav" 
                        aria-controls="navbarNav" 
                        aria-expanded="false" 
                        aria-label="Toggle navigation"
                    >
                        <i className="fa-solid fa-bars"></i>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className={`navbar-nav ${language === 'ar' ? 'm-auto' : 'm-auto'} mb-2 mb-lg-0 align-items-center`}>
                            {routes.map((route, index) => (
                                <li className="nav-item" key={index}>
                                    <a
                                        href={route.link}
                                        onClick={(e) => handleNavigation(e, route.link)}
                                        className="nav-link text-white"
                                        data-aos="fade-down"
                                        data-aos-delay={index * 100}
                                    >
                                        {route.name}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        <div className="language-selector d-flex align-items-center justify-content-center">
                            <div className="dropdown">
                                <i 
                                    className="fa-solid fa-globe text-white fs-5" 
                                    type="button" 
                                    data-bs-toggle="dropdown" 
                                    aria-expanded="false"
                                    style={{ cursor: 'pointer' }}
                                ></i>
                                <ul className={`dropdown-menu dropdown-menu-${language === 'ar' ? 'end' : 'start'} text-center border-0 mt-2`} style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: '-50px',
                                    right: 'auto',
                                    margin: '0 auto',
                                }}>
                                    <li>
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => setLanguage('en')}
                                        >
                                            English
                                        </button>
                                    </li>
                                    <li>
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => setLanguage('ar')}
                                        >
                                            العربية
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Navbar;
